module.exports = __webpack_public_path__ + "files/9dbc44325c4ef3209b67644ae2d40360.png";